import React, { useState } from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from '../Shared/Button';
import Form from 'react-bootstrap/Form';

const FishPopup = ({ show, handleClose }) => {

  return (
    <Modal show={show} onHide={handleClose} style={{ zIndex: 9999 }}>
      <Modal.Header closeButton>
        <Modal.Title>Ops!</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        <h2>Coming soon!</h2>
        <img style={{ width: '200px' }}
          src="https://firebasestorage.googleapis.com/v0/b/riotlabs-web.appspot.com/o/images%2Fsadfish.png?alt=media&token=ac69e446-cedd-478e-b265-65ead4c42d1a"
          alt="your-image-alt-text-here" />
      </Modal.Body>
      <Modal.Footer>
      <Button buttonStyle='pink' text='Close' onClick={handleClose}/>
      </Modal.Footer>
    </Modal>
  );
};

export default FishPopup;